import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import EthSvg from 'assets/icons/eth.svg';

import PptType from 'assets/icons/property/type.svg';
import PptAddress from 'assets/icons/property/address.svg';
import PptCity from 'assets/icons/property/city.svg';
import PptColor from 'assets/icons/property/color.svg';
import PptCountry from 'assets/icons/property/country.svg';
import PptState from 'assets/icons/property/state.svg';

interface PropertyProps {
  propertyImage?: string;
  propertyName?: string;
  propertyOwner?: string;
  ownerPicture?: string;
  propertyPrice?: any;
  propertyMaxPrice?: any;
  propertyDescription?: string;
  propertyAdress?: string;
  propertyType?: string;
  propertyCreatedOn?: string;
  propertyId?: string;
  propertySlug?: string;
}

/** TODO: Create Property Card Component */
const Property: FC<PropertyProps> = ({
  propertyImage,
  propertyName,
  propertyOwner,
  ownerPicture,
  propertyPrice,
  propertyMaxPrice,
  propertyDescription,
  propertyAdress,
  propertyType,
  propertyCreatedOn,
  propertyId,
  propertySlug,
}) => {
  const history = useNavigate();

  return (
    <div
      className="group flex items-end bg-no-repeat bg-cover bg-center rounded-[30px] w-full h-[550px]"
      style={{ backgroundImage: `url(${propertyImage})` }}
      onClick={() => {
        history(`/property/${propertySlug}`);
      }}
      onKeyDown={() => {
        history(`/property/${propertySlug}`);
      }}
      role="button"
      tabIndex={0}
    >
      <div className=" flex flex-col bg-black/80 rounded-[30px] w-full p-14 ">
        <div className="flex justify-between items-center">
          <h3 className="uppercase text-white bg-opacity-80 font-bold text-[28px] lg:text-[32px] font-brandon">
            {propertyName}
          </h3>
          <div className="flex align-center">
            <img className="mt-1 mr-1" src={EthSvg} alt="" />
            <p className="text-white text-lg font-bold">{propertyPrice}</p>
            {/* {propertyMaxPrice && (
              <p className="text-white text-lg font-bold">
                Buyout: {propertyMaxPrice}
              </p>
            )} */}
          </div>
        </div>

        <p className="text-white">{propertyDescription}</p>

        <div className="flex items-center">
          <p className="text-base text-primary-2 hidden sm:block">Owner -</p>
          <p className="text-white ml-1"> {propertyOwner}</p>
        </div>

        <div className="hidden group-hover:block mt-6">
          <div className="flex items-center">
            <div className="rounded-full border border-white/70 flex align-center p-2">
              <img className="w-4 h-4" src={PptType} alt="" />
            </div>
            <div className="flex flex-col ml-4">
              <p className="text-xs font-light text-white/75">Property Type</p>
              <p className="text-sm	font-normal	text-white/75">{propertyType}</p>
            </div>
          </div>

          <div className="flex items-center mt-4">
            <div className="rounded-full border border-white/70 flex align-center p-2">
              <img className="w-4 h-4" src={PptColor} alt="" />
            </div>
            <div className="flex flex-col ml-4">
              <p className="text-xs font-light text-white/75">Created On</p>
              <p className="text-sm	font-normal	text-white/75">
                {propertyCreatedOn}
              </p>
            </div>
          </div>

          {/* <div className="flex items-center mt-4">
          <div className="rounded-full border border-white/70 flex align-center p-2">
            <img className="w-4 h-4" src={PptCountry} alt="" />
          </div>
          <div className="flex flex-col ml-4">
            <p className="text-xs font-light text-white/75">Country</p>
            <p className="text-sm	font-normal	text-white/75">United States</p>
          </div>
        </div>

        <div className="flex items-center mt-4">
          <div className="rounded-full border border-white/70 flex align-center p-2">
            <img className="w-4 h-4" src={PptState} alt="" />
          </div>
          <div className="flex flex-col ml-4">
            <p className="text-xs font-light text-white/75">State</p>
            <p className="text-sm	font-normal	text-white/75">Califonia</p>
          </div>
        </div>

        <div className="flex items-center mt-4">
          <div className="rounded-full border border-white/70 flex align-center p-2">
            <img className="w-4 h-4" src={PptCity} alt="" />
          </div>
          <div className="flex flex-col ml-4">
            <p className="text-xs font-light text-white/75">City</p>
            <p className="text-sm	font-normal	text-white/75">Bay Area</p>
          </div>
        </div> */}

          <div className="flex items-center mt-4">
            <div className="rounded-full border border-white/70 flex align-center p-2">
              <img className="w-4 h-4" src={PptAddress} alt="" />
            </div>
            <div className="flex flex-col ml-4">
              <p className="text-xs font-light text-white/75">Address</p>
              <p className="text-sm	font-normal	text-white/75">
                {propertyAdress}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Property;
